export enum COST_DASHBOARD_VARIANT {
  ROLLUP = 'ROLLUP',
  RAAS = 'RAAS',
}

export const COST_SUMMARY_KINDS = {
  SERVICE: 'SERVICE',
  INGRESS: 'INGRESS',
  NODE: 'NODE',
  PERSISTENT_VOLUME: 'PERSISTENT_VOLUME',
  POD: 'POD',
};

export const COST_SUMMARY_TYPES = {
  COMPUTE: 'COMPUTE',
  STORAGE: 'STORAGE',
  NETWORK: 'NETWORK',
};

export const SUB_RESOURCE = {
  COMPUTE: 'COMPUTE',
  DATA_TRANSFER: 'DATA_TRANSFER',
  PUBLIC_IPV4: 'PUBLIC_IPV4',
  ELB_HOURLY: 'ELB_HOURLY',
  ROOT_VOLUME: 'ROOT_VOLUME',
  EBS_VOLUME: 'EBS_VOLUME',
};

export const BUSINESS = {
  FULL_NODE: 'fullnode',
  BLOCKSCOUT: 'blockscout',
  CLOUD_SERVICE: 'cloud_service',
  ROLLUP_COMPONENTS: 'rollup_components',
  OTHERS: 'others',
};

export const BUSINESS_LABEL = {
  [BUSINESS.ROLLUP_COMPONENTS]: 'Rollup Components',
  [BUSINESS.FULL_NODE]: 'Full Node',
  [BUSINESS.BLOCKSCOUT]: 'Blockscout',
  [BUSINESS.CLOUD_SERVICE]: 'Cloud Service',
  [BUSINESS.OTHERS]: 'Others',
};

export const CATEGORY = {
  ORBIT_DEMO: 'orbit-demo',
  LAYER_1: 'layer1',
  DA: 'da',
  RPC: 'rpc',
  L1_PROXY: 'l1-proxy',
};

export const CATEGORY_LABEL = {
  [CATEGORY.ORBIT_DEMO]: 'Orbit Demo',
  [CATEGORY.LAYER_1]: 'Layer 1',
  [CATEGORY.DA]: 'DA',
  [CATEGORY.RPC]: 'RPC',
  [CATEGORY.L1_PROXY]: 'L1 Proxy',
};

export const COST_SUMMARY_KINDS_OPTIONS = [
  { label: 'All Kinds', value: 'ALL' },
  { label: 'Service', value: COST_SUMMARY_KINDS.SERVICE },
  { label: 'Ingress', value: COST_SUMMARY_KINDS.INGRESS },
  { label: 'Node', value: COST_SUMMARY_KINDS.NODE },
  { label: 'Persistent Volume', value: COST_SUMMARY_KINDS.PERSISTENT_VOLUME },
  { label: 'Pod', value: COST_SUMMARY_KINDS.POD },
];

export const COST_SUMMARY_TYPES_OPTIONS = [
  { label: 'All Types', value: 'ALL' },
  { label: 'Compute', value: COST_SUMMARY_TYPES.COMPUTE },
  { label: 'Storage', value: COST_SUMMARY_TYPES.STORAGE },
  { label: 'Network', value: COST_SUMMARY_TYPES.NETWORK },
];

export const SUB_RESOURCE_LIST_OPTIONS = [
  { label: 'All sub-resources', value: 'ALL' },
  { label: 'Compute', value: SUB_RESOURCE.COMPUTE },
  { label: 'Data Transfer', value: SUB_RESOURCE.DATA_TRANSFER },
  { label: 'Public IPv4', value: SUB_RESOURCE.PUBLIC_IPV4 },
  { label: 'ELB Hourly', value: SUB_RESOURCE.ELB_HOURLY },
  { label: 'Root Volume', value: SUB_RESOURCE.ROOT_VOLUME },
  { label: 'EBS Volume', value: SUB_RESOURCE.EBS_VOLUME },
];

export const BUSINESS_LIST_OPTIONS = [
  { label: 'Rollup Components', value: BUSINESS.ROLLUP_COMPONENTS },
  { label: 'Full Node', value: BUSINESS.FULL_NODE },
  { label: 'Blockscout', value: BUSINESS.BLOCKSCOUT },
  { label: 'Cloud Service', value: BUSINESS.CLOUD_SERVICE },
  { label: 'Others', value: BUSINESS.OTHERS },
];

export const CATEGORY_LIST_OPTIONS = [
  { label: CATEGORY_LABEL[CATEGORY.ORBIT_DEMO], value: CATEGORY.ORBIT_DEMO },
  { label: CATEGORY_LABEL[CATEGORY.LAYER_1], value: CATEGORY.LAYER_1 },
  { label: CATEGORY_LABEL[CATEGORY.DA], value: CATEGORY.DA },
  { label: CATEGORY_LABEL[CATEGORY.RPC], value: CATEGORY.RPC },
  { label: CATEGORY_LABEL[CATEGORY.L1_PROXY], value: CATEGORY.L1_PROXY },
];
